import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
// import StyledHero from "../components/StyledHero"
import styles from "../css/template.module.css"
import Img from "gatsby-image"
import { FaMap, FaArrowLeft} from "react-icons/fa"
// import Day from "../components/SingleTour/Day"
import AniLink from "gatsby-plugin-transition-link/AniLink"



const Template = ({ data }) => {
  const {
    name,
    project,
    description: { description },
    images,

  } = data.tour

  const [mainImage, ...projectImages] = images

  return (
    <Layout>
  
      
      <section className={styles.template}>
      <AniLink fade to="/projects" className={styles.chevronleft}>
            <FaArrowLeft/>
          </AniLink>
        <div className={styles.center}>
        <h2>{name}</h2>
        <h4>Case Study (Problem)</h4>
          <p className={styles.desc}>{description}</p>
          <div className={styles.images}>
            {projectImages.map((item, index) => {
              return (
                <Img
                  key={index}
                  fluid={item.fluid}
                  alt="single tour"
                  className={styles.image}
                />
              )
            })}
          </div>
          <div className={styles.info}>
        
            <p>
              <FaMap className={styles.icon} />
      {project}
            </p>
          </div>
          
          
    
          <AniLink fade to="/projects" className="btn-primary">
            back to Projects
          </AniLink>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
query($slug: String!) {
  tour: contentfulTour(slug: { eq: $slug }) {
    name
    project
    description {
      description
    }
    accordian {

      info
    }
    images {
      fluid {
        ...GatsbyContentfulFluid
      }
    }
  }
}
`


/* <div className={styles.journey}>
{accordian.map((item, index) => {
  return <Day key={index} day={item.day} info={item.info} />
})}
</div> */

export default Template
